import { db } from "config/firebaseConfig";
import { addDoc, collection, deleteDoc, doc, setDoc } from "firebase/firestore";
import React, { useState } from "react";

import { useMemo } from "react";
import { AiFillEdit } from "react-icons/ai";
import { FaTrash } from "react-icons/fa";
import { MdAddCircleOutline, MdCancel, MdSave } from "react-icons/md";
import { useTable, useSortBy } from "react-table";

import Swal from "sweetalert2";

const ConfigurationTable = ({ data, setData, collectioPath, headerTitle }) => {
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [rowNumber, setRowNumber] = useState(null);
  const [name, setName] = useState("");
  const [saveName, setSaveName] = useState("");

  const handleAdd = async () => {
    let names = data.slice();
    let newName = { name: name };

    await addDoc(collection(db, collectioPath), newName).then(async (doc) => {
      newName.id = doc.id;
      await setDoc(doc, newName);
    });
    Swal.fire({
      title: "Success",
      text: "Added successfully !",
      icon: "success",
      background: "#374151",
      color: "rgb(226,232,240)",
      showConfirmButton: false,
      timer: 1500,
    });
    names.push(newName);
    names.sort((a, b) => a.name.localeCompare(b.name));
    setData(names);
    setName("");
  };

  const handleSave = async (row) => {
    let editName = { id: row.id, name: saveName };
    await setDoc(doc(db, collectioPath, row.id), editName);
    Swal.fire({
      title: "Success",
      text: "Saved successfully !",
      icon: "success",
      background: "#374151",
      color: "rgb(226,232,240)",
      showConfirmButton: false,
      timer: 1500,
    }).then(() => {
      let names = data.slice();
      let filter = names.filter((name) => name.id !== row.id);

      filter.push(editName);
      filter.sort((a, b) => a.name.localeCompare(b.name));
      setData(filter);
      setSaveName("");
    });
  };

  const handleDelete = async (row) => {
    Swal.fire({
      title: "Are you sure ?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "rgb(239,68,68)",
      cancelButtonColor: "#25bdf9",
      confirmButtonText: "Yes,delete it !",
      cancelButtonText: "Cancel",
      background: "#374151",
      color: "rgb(226,232,240)",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await deleteDoc(doc(db, `${collectioPath}/${row.id}`));
        const filter = data.filter((name) => name.name !== row.name);

        setData(filter);
        Swal.fire({
          title: "Success",
          text: "Deleted successfully !",
          icon: "success",
          background: "#374151",
          color: "rgb(226,232,240)",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    });
  };

  const columns = useMemo(
    () => [
      {
        Header: "id",
        accessor: "id",
      },
      {
        Header: headerTitle,
        accessor: "name",
      },
    ],
    [headerTitle]
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
        initialState: { hiddenColumns: ["id"] },
      },
      useSortBy
    );
  return (
    <>
      <button
        onClick={() => {
          setShowAdd(true);
        }}
        className="flex ml-1  items-center justify-center space-x-2 bg-blue-500 hover:bg-blue-500/70 px-3 py-2 mb-2 rounded transition-all duration-300 ease-out shadow-lg"
      >
        <span>Add</span> <MdAddCircleOutline className="w-5 h-5" />
      </button>

      {showAdd && (
        <div className=" flex justify-between items-center bg-sidebar px-5 py-2 rounded my-2">
          <input
            onChange={(e) => {
              setName(e.target.value);
            }}
            value={name}
            className="text-slate-300  w-1/2 bg-slate-600 px-2 py-1 rounded  outline-none focus:ring-1 ring-primary  "
            placeholder="Enter new record ..."
          />
          <div className="flex space-x-2">
            <button
              onClick={handleAdd}
              className="bg-primary/70 hover:bg-primary text-white px-3 py-2 rounded"
            >
              <MdSave className="w-5 h-5" />
            </button>
            <button
              onClick={() => setShowAdd(false)}
              className="bg-red-500/70 px-3 py-2 text-white hover:bg-red-500 rounded"
            >
              <MdCancel className="w-5 h-5" />
            </button>
          </div>
        </div>
      )}
      <div className="bg-secondary/80  rounded-lg text-sm  ">
        <table
          {...getTableProps()}
          className=" w-full rounded-lg overflow-hidden       "
        >
          <thead className="h-[70px] absolute    border-b-2  border-primary  invisible  md:visible md:static   ">
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, i) => (
                  <th
                    className="pl-5 text-left"
                    key={i}
                    {...column.getHeaderProps()}
                  >
                    <span {...column.getSortByToggleProps()}>
                      {column.render("Header")}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody className="bg-gray-700/90" {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr
                  onClick={() => {
                    // console.log(row.original);
                  }}
                  className="flex flex-col justify-center cursor-pointer  md:h-[50px] h-full py-5   md:text-left  md:table-row hover:bg-slate-700     border-b border-slate-900/50  "
                  key={i}
                  {...row.getRowProps()}
                >
                  {row.cells.map((cell, i) => {
                    return (
                      <td
                        data-heading={cell.column.Header}
                        className={`   flex md:table-cell before:px-3 before:md:absolute before:md:invisible md:pl-5   before:relative before:w-[100px]      before:text-slate-300  before:content-[attr(data-heading)]    `}
                        key={i}
                        {...cell.getCellProps()}
                      >
                        {showEdit &&
                        rowNumber === row.id &&
                        cell.column.id !== "id" ? (
                          <input
                            className="text-slate-300 w-1/2  bg-slate-600 px-2 py-1 rounded  outline-none focus:ring-1 ring-primary "
                            defaultValue={row.cells[i].value}
                            onChange={(e) => {
                              setSaveName(e.target.value);
                            }}
                          />
                        ) : (
                          cell.render("Cell")
                        )}
                      </td>
                    );
                  })}
                  <td className=" pt-5 md:pt-0  sm:w-1/3  text-center align-middle flex md:table-cell flex-col w-1/2 self-center space-y-2 md:space-y-0 md:space-x-2  md:w-fit ">
                    <div className="flex items-center justify-end space-x-2 px-4">
                      {showEdit && rowNumber === row.id ? (
                        <button
                          className="flex md:table-cell justify-center  items-center  transition-all hover:bg-blue-500 px-3 py-2  rounded "
                          onClick={() => {
                            setShowEdit(false);
                            handleSave(row.original);
                          }}
                        >
                          <MdSave className=" w-4 h-4" />
                        </button>
                      ) : (
                        <button
                          className="flex md:table-cell justify-center  items-center  transition-all hover:bg-blue-500 px-3 py-2  rounded "
                          onClick={() => {
                            setRowNumber(row.id);
                            setShowEdit(true);
                            setSaveName(row.cells[0].value);
                          }}
                        >
                          <AiFillEdit className=" w-4 h-4" />
                        </button>
                      )}

                      <button
                        onClick={() => {
                          handleDelete(row.original);
                        }}
                        className="flex md:table-cell justify-center  items-center group  hover:bg-red-500 px-3 py-2  rounded disabled:bg-gray-500 disabled:text-slate-700"
                      >
                        <span className="flex ">
                          <FaTrash className=" w-4 h-4 text-red-400/90 group-hover:text-slate-200" />
                        </span>
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ConfigurationTable;
